var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Ogólnodostępne materiały dla lektorów")]),_c('course-materials-view',{staticClass:"materials",attrs:{"for-whom":"for_lecturers"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }